import { Typography, useTheme } from "@mui/material"
import IFrameModal from "../IFrameModal";
import { useState } from "react";

export const MacOSHelpGuide = () => {
  const guideUrl = "https://sbxcorp.atlassian.net/wiki/external/Y2U5MmU3MWRkNjgyNGI4MmI5NjhiMmFjOWQ5NjZiYjI";
  const [confluenceModalContent, setConfluenceModalContent] = useState(guideUrl);
  const [confluenceModalIsOpen, setConfluenceModalIsOpen] = useState(false);
  const handleCloseConfluenceModal = () => {
    setConfluenceModalIsOpen(false);
    setConfluenceModalContent("");
  }

  const theme = useTheme();
    return(
        <Typography variant="caption" style={{color: theme.palette.text.secondary }}>
          Mac Users: Facing issues with installing Garuda on Mac? <Typography variant="caption" color={theme.palette.primary.main} sx={{textDecoration: "underline", cursor: "pointer"}} onClick={()=>setConfluenceModalIsOpen(true)}>Click here</Typography>
          <IFrameModal
                  modalContent={confluenceModalContent}
                  handleCloseModal={handleCloseConfluenceModal}
                  isModalOpen={confluenceModalIsOpen}
                />
        </Typography>
    )
}